<!-- Basic search -->
<ng-container *ngIf="appearance === 'basic'">
    <div class="w-full sm:min-w-80">
        <mat-form-field
            class="w-full"
            [subscriptSizing]="'dynamic'">
            <mat-icon
                matPrefix
                [svgIcon]="icon"></mat-icon>
            <input
                matInput
                [formControl]="searchControl"
                [matAutocomplete]="matAutocomplete"
                [placeholder]="placeHolder"
                (keydown)="onKeydown($event)">
        </mat-form-field>
        <mat-autocomplete
            class="max-h-128 mt-1 rounded"
            [autoSelectActiveOption]="true"
            [disableRipple]="true"
            (optionSelected) = "selectedOption($event.option.value)"
            [displayWith]="displayDinamicKeySearch"
            #matAutocomplete="matAutocomplete">
            <mat-option
                class="py-0 px-6 text-md pointer-events-none text-secondary bg-transparent"
                *ngIf="resultSets && !resultSets.length">
                No se encontraron resultados!
            </mat-option>
             <ng-container *ngFor="let result of resultSets; trackBy: trackByFn">
                    <mat-option
                        class="group relative mb-1 py-0 px-6 text-md rounded-md hover:bg-gray-100 dark:hover:bg-hover"
                        [value]="result"
                        >
                        <ng-container>
                            <ng-container *ngTemplateOutlet="contactResult; context: {$implicit: result}"></ng-container>
                        </ng-container>
                    </mat-option>
                </ng-container>
        </mat-autocomplete>
    </div>
</ng-container>

<!-- Person result template -->
<ng-template
    #contactResult
    let-result>
    <div class="flex items-center">
        <div class="ml-3 truncate">
            <span [innerHTML]="displayDinamicKeySearch(result, displayInformation)"></span>
        </div>
    </div>
</ng-template>

<!-- Person result template -->
<ng-template
    #taskResult
    let-result>
    <div class="flex items-center">
        <div class="ml-3 truncate">
            <span [innerHTML]="displayDinamicKeySearch(result)"></span>
        </div>
    </div>
</ng-template>

